var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "att-panel" }, [
    _c("div", { staticClass: "card-body p-0" }, [
      _c("div", { staticClass: "att-header" }, [
        _c("span", { staticClass: "att-title capitalize" }, [
          _vm._v(_vm._s(_vm.attributesName)),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "att-header-actions" },
          [
            _vm.attributesName == "errors"
              ? [
                  _c(
                    "b-button",
                    {
                      staticClass: "att-nav-btn",
                      attrs: { size: "sm", disabled: _vm.disabledPrevious },
                      on: {
                        click: function ($event) {
                          return _vm.getNextError(false)
                        },
                      },
                    },
                    [_vm._v("\n            Prev\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "att-nav-btn",
                      attrs: { size: "sm", disabled: _vm.disabledNext },
                      on: {
                        click: function ($event) {
                          return _vm.getNextError(true)
                        },
                      },
                    },
                    [_vm._v("\n            Next\n          ")]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "att-icon-btn",
                attrs: {
                  id: "minOrMaxAttributeElement",
                  type: "button",
                  title: _vm.attributesMinimized
                    ? "Maximize Attributes"
                    : "Minimize Attributes",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit(
                      _vm.attributesMinimized
                        ? "maximizeAttributes"
                        : "minimizeAttributes"
                    )
                  },
                },
              },
              [
                _c("fa", {
                  attrs: {
                    icon: [
                      "fas",
                      _vm.attributesMinimized
                        ? "window-maximize"
                        : "window-minimize",
                    ],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "att-icon-btn att-close",
                attrs: {
                  type: "button",
                  title: "Close",
                  "aria-label": "Close",
                },
                on: {
                  click: function ($event) {
                    return _vm.closeAttTable()
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "times"] } })],
              1
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.attributesMinimized,
              expression: "!attributesMinimized",
            },
          ],
          staticClass: "att-body scroll-Container",
        },
        [
          _vm._l(_vm.attribResponse, function (resp, index) {
            return resp.name != "is_active"
              ? _c("div", { key: index, staticClass: "att-row" }, [
                  _c("div", { staticClass: "att-name" }, [
                    _vm._v(_vm._s(resp.name)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "att-value",
                      attrs: { id: "editor" + index, title: "Copy value" },
                      on: {
                        click: function ($event) {
                          return _vm.copyText(resp.value)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "att-value-text" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              resp.name == "created_at" ||
                                resp.name == "created_date" ||
                                resp.name == "updated_date" ||
                                resp.name == "updated_on"
                                ? resp.value
                                  ? resp.value.replace("Z", "")
                                  : resp.value
                                : resp.value
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("fa", {
                        staticClass: "att-copy-icon",
                        attrs: { icon: ["fas", "copy"] },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.attributesName.toLowerCase().includes("otonomo") &&
          _vm.globalIsUserAllowed("Otonomo_Status")
            ? _c(
                "div",
                { staticClass: "att-otonomo" },
                [
                  _c("span", { staticClass: "att-otonomo-label" }, [
                    _vm._v("Speed limit status"),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "att-radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.status,
                          expression: "status",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        name: "typeFilter",
                        title: "Active",
                      },
                      domProps: {
                        value: true,
                        checked: _vm._q(_vm.status, true),
                      },
                      on: {
                        change: [
                          function ($event) {
                            _vm.status = true
                          },
                          function ($event) {
                            _vm.showBtn = true
                          },
                        ],
                      },
                    }),
                    _vm._v("\n          Active\n        "),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "att-radio" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.status,
                          expression: "status",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        name: "typeFilter",
                        title: "Inactive",
                      },
                      domProps: {
                        value: false,
                        checked: _vm._q(_vm.status, false),
                      },
                      on: {
                        change: [
                          function ($event) {
                            _vm.status = false
                          },
                          function ($event) {
                            _vm.showBtn = true
                          },
                        ],
                      },
                    }),
                    _vm._v("\n          Inactive\n        "),
                  ]),
                  _vm._v(" "),
                  _vm.showBtn
                    ? _c(
                        "b-button",
                        {
                          staticClass: "att-update-btn",
                          attrs: {
                            variant: "primary",
                            size: "sm",
                            id: "submitBtn",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.updateOtonomo()
                            },
                          },
                        },
                        [_vm._v("\n          Update\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.attributesMinimized,
              expression: "!attributesMinimized",
            },
          ],
          staticClass: "att-footer",
        },
        [
          _c("div", { staticClass: "att-pager" }, [
            _c(
              "button",
              {
                staticClass: "att-pager-btn",
                attrs: { type: "button", disabled: _vm.feature_index < 1 },
                on: {
                  click: function ($event) {
                    return _vm.getNextFeature(-1)
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "chevron-left"] } })],
              1
            ),
            _vm._v(" "),
            _c("span", { staticClass: "att-pager-count" }, [
              _vm._v(
                _vm._s(_vm.feature_index + 1) +
                  " of " +
                  _vm._s(_vm.features.length)
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "att-pager-btn",
                attrs: {
                  type: "button",
                  disabled: _vm.feature_index + 1 >= _vm.features.length,
                },
                on: {
                  click: function ($event) {
                    return _vm.getNextFeature(1)
                  },
                },
              },
              [_c("fa", { attrs: { icon: ["fas", "chevron-right"] } })],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "close-btn",
              on: {
                click: function ($event) {
                  return _vm.closeAttTable()
                },
              },
            },
            [_vm._v("Close")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }